import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconCustomize from 'components/icons/iconCustomize2';
import { colorBrand } from 'styles/layout/colors';
const PDPFreeSwatchKitButton = t0 => {
  const $ = _c(11);
  const {
    onClick: t1,
    styling: t2,
    block: t3
  } = t0;
  const onClick = t1 === undefined ? _temp : t1;
  const styling = t2 === undefined ? "link" : t2;
  const block = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== block) {
    t4 = classNames("text-sm font-bold items-center text-brand flex hover:!underline whitespace-nowrap", {
      "justify-center": block
    });
    $[0] = block;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconCustomize color={colorBrand} height={16} width={22} className="!mr-2" />;
    t6 = <span>Get free swatches</span>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4) {
    t7 = <span className={t4}>{t5}{t6}</span>;
    $[4] = t4;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== block || $[7] !== onClick || $[8] !== styling || $[9] !== t7) {
    t8 = <CtaButton styling={styling} color="brand" hasArrow={false} block={block} data-xc="PDPGetFreeSwatchesButton" onClick={onClick} className="PDPFreeSwatchKitButton">{t7}</CtaButton>;
    $[6] = block;
    $[7] = onClick;
    $[8] = styling;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
PDPFreeSwatchKitButton.propTypes = {
  onClick: PropTypes.func,
  styling: PropTypes.string,
  block: PropTypes.bool
};
export default PDPFreeSwatchKitButton;
function _temp() {}